import {getData} from '@utils/helpers/storage';

export const isLoggedIn = () => getData('bbq_user') ? true: false;
